import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
// @ts-expect-error - TODO: fix this
import CommunicationTemplateEditor from "./Communication/CommunicationTemplateEditor";
import DocumentTemplateUpload from "./DocumentTemplateUpload";
import { MESSAGE_TYPE } from "../../../constants";
import "./styles/style.css";

const TemplateEditorWrapper = () => {
  const { messageType, templateId } = useParams();

  return (
    <Grid container item height="100%" width="100%" spacing={1} direction="row">
      {messageType === MESSAGE_TYPE.DOCUMENT ? (
        <DocumentTemplateUpload templateId={templateId || ''} />
      ) : (
        <CommunicationTemplateEditor templateId={templateId || ''} />
      )}
    </Grid>
  );
};

export default TemplateEditorWrapper;
